/** @format */

import {Box} from '@mui/material';

import {YalperPlatform} from 'graphql/generated/types';

import {sensorName} from 'helpers/sensor_names';
import categoriesData from 'pages/Home/Main/Project/data/categories.json';

import {Group} from '..';
import {StyledBox, classes} from './styles';
import {SelectableListCategory} from './SelectableListCategory';

interface SensorWithName {
  id: string;
  humanName: string;
}

interface CategoriesWithSensorNames {
  name: string;
  title: string;
  description: string;
  sensors: SensorWithName[];
}

const categoriesDataWithNames: CategoriesWithSensorNames[] = categoriesData.map(el => {
  const sensors = el.sensors.map(sensor => {
    const humanName = sensorName(sensor);
    return {id: sensor, humanName};
  });
  return {...el, sensors};
});

interface SelectableListProps {
  list: string[];
  filter?: string;
  groups: Group[];
  className?: string;
  selected: Set<string>;
  platformsByName: ReadonlyMap<string, ReadonlyArray<YalperPlatform>>;
  onUpdate: (sensor: string | Set<string>) => void;
}

export const SelectableList = ({
  list,
  groups,
  filter,
  onUpdate,
  className,
  platformsByName,
  selected = new Set(),
}: SelectableListProps) => {
  const processedCategories = categoriesDataWithNames.map(data => ({
    ...data,
    sensors: data.sensors
      .filter(({id, humanName}) => {
        if (filter) {
          return list.includes(id) && humanName.toLowerCase().includes(filter.trim().toLowerCase());
        }
        return list.includes(id);
      })
      .map(sensor => {
        const group = groups.find(group => group.sensors.includes(sensor.id));
        return {...sensor, group};
      }),
  }));

  return (
    <StyledBox className={className}>
      <Box className={classes.selectableList}>
        {processedCategories.map(category => (
          <SelectableListCategory
            selected={selected}
            key={category.name}
            category={category}
            groups={groups}
            platformsByName={platformsByName}
            onUpdate={onUpdate}
          />
        ))}
      </Box>
    </StyledBox>
  );
};
